export default {
    addActive: "/v1/activityitem/add"
}